<template>
  <div class="reward-box flex flex-col">
    <div class="reward-icon-url relative mb-2">
      <router-link
        v-if="showLink"
        :to="`/loyalty-programme/rewards/${reward.id}`"
      >
        <img v-if="reward.iconUrl" :src="reward.iconUrl" alt="reward-icon" class="rounded-xl" />
      </router-link>
      <img v-else-if="reward.iconUrl" :src="reward.iconUrl" alt="reward-icon" class="rounded-xl" />

      <button
        :disabled="loadingFavourite"
        @click="editFavourite(reward.id)"
        :title="$t('loyalty-programme.favourite')"
        class="ml-1 absolute top-1 right-2"
      >
        <InlineIconSpinner v-if="loadingFavourite" inverted />
        <font-awesome-icon v-else-if="favourite" :icon="['fas', 'heart']" :style="{color: color}" size="lg" />
        <font-awesome-icon v-else :icon="['fas', 'heart']" :style="{color: 'white'}" size="lg" />
      </button>
    </div>

    <div class="reward-name">
      <router-link
        v-if="showLink"
        :to="`/loyalty-programme/rewards/${reward.id}`"
        class="reward-title text-sm"
        v-html="reward.name[$i18n.locale]"
      >
      </router-link>
      <p v-else class="reward-title text-sm" v-html="reward.name[$i18n.locale]"></p>
    </div>
  </div>
</template>

<script setup lang="ts">
import InlineIconSpinner from "@/components/InlineIconSpinner.vue";
import { PropType, ref } from "vue";
import { BusinessPartnerRole } from "@/models/businessPartner";
import { LoyaltyReward } from "@/models/loyaltyReward";
import { useLoyalty } from "@/pinia/loyaltyStore";

const props = defineProps({
  reward: {
    type: Object as PropType<LoyaltyReward>,
    required: true
  },
  color: {
    type: String,
    required: false
  },
  favourite: {
    type: Boolean,
    required: false
  },
  showLink: {
    type: Boolean,
    required: false,
    default: true
  }
})

const loyaltyStore = useLoyalty();

const loadingFavourite = ref(false);

function editFavourite(rewardId: number) {
console.log('editFavourite', rewardId);
  loadingFavourite.value = true;
  loyaltyStore.editFavouriteReward(rewardId);

  loadingFavourite.value = false;
}
</script>
